export const MAX_CHECKOUT_LINE_ITEM_LENGTH = 100
export const MAX_CHECKOUT_LINE_ITEMS = 6
